import { Pipe, PipeTransform } from '@angular/core';

const capitalizeTxt = (txt: string) => txt.charAt(0).toUpperCase() + txt.slice(1);

@Pipe({name: 'hashtag'})
export class HashtagPipe implements PipeTransform {
  transform(value: string): string {
    value = value.replace(/[/.,!?;]*/g, '');
    value = value.split(' ').map((w) => capitalizeTxt(w)).join('');
    return `#${value}`;
  }
}
